import { createSelector } from 'reselect'
import API from '../../../utils/http/api'

// Actions
const REQUEST = "steppingblocks/subscriptionCancellation/REQUEST"
const SUCCESS = "steppingblocks/subscriptionCancellation/SUCCESS"
const FAILURE = "steppingblocks/subscriptionCancellation/FAILURE"
const OPEN = 'steppingblocks/subscriptionCancellation/OPEN'
const CLOSE = 'steppingblocks/subscriptionCancellation/CLOSE'
const SELECT_OPTION = 'steppingblocks/subscriptionCancellation/SELECT_OPTION'

const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  isShowingModal: false,
  selectedOption: null,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case OPEN:
      return { ..._state, isShowingModal: true }
    case CLOSE:
      return { ..._state, isShowingModal: false, selectedOption: null }
    case SELECT_OPTION:
      return {
        ..._state,
        selectedOption: payload.option,
      }
    default:
      return _state
  }
}

export const openModal = () => ({ type: OPEN })

export const closeModal = () => ({ type: CLOSE })

export const selectOption = option => ({
  type: SELECT_OPTION,
  payload: { option },
})

export const performCancelSubscription = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { user } = await API.post('/payments/stripe/subscription/cancel', params)
    dispatch({ type: SUCCESS })
    return user
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error.message)
  }
}

const baseKey = state => state.subscriptionCancellation

export const isRequestingCancellation = createSelector(
  baseKey,
  data => data.requestStarted && !data.requestEnded
)

export const getIsShowingModal = createSelector(
  baseKey,
  data => data.isShowingModal,
)

export const getIsCancelledSuccessfully = createSelector(
  baseKey,
  data => data.requestStarted && data.requestEnded && !data.error,
)

export const getSelectedOption = createSelector(
  baseKey,
  data => data.selectedOption
)



// WEBPACK FOOTER //
// ./src/components/ui/SubscriptionCancellation/subscriptionCancellationDuck.js